import styles from './styles.module.scss'
import clsx from 'clsx'

export const RadioGroup = ({
  label,
  options,
  currentValue,
  onClick,
  name,
  ...props
}) => (
  <div {...props}>
    <div className={styles.groupLabel}>{label}</div>
    <div className={styles.mainWrapper}>
      {options.map(radio => (
        <div
          key={radio}
          className={styles.radioWrapper}
          onClick={() => onClick({ name, value: radio })}
        >
          <div
            className={clsx(styles.input, {
              [styles.active]: currentValue === radio,
            })}
          />
          <div className={styles.label}>{radio}</div>
        </div>
      ))}
    </div>
  </div>
)

export default RadioGroup
